import styled from 'styled-components';
import { BareIconButton, alpha, getSpacingToken, getToken, mediaMaxWidth } from '@optimus-web/core';
import { BreakpointRange } from '@mews-commander/ui';
import { MatrixCellWrapperElement, MatrixHeaderCellElement } from '../../../../../../components/commander-ui/Matrix';
import { TimeUnitMatrixCell } from '../../../../../../components/commander-ui';
import { getGreyBorderStyle } from '../styles';
import { TOTAL_CELL_HEIGHT } from '../../../../constants';

const DEFAULT_SPACING = getSpacingToken('200');

export const BlockSetUpAsideWrapperRow = styled(MatrixCellWrapperElement)`
    width: 348px;
    border-bottom: ${getGreyBorderStyle};
    ${mediaMaxWidth(BreakpointRange.Tablet.value)} {
        width: 264px;
    }
    ${mediaMaxWidth(BreakpointRange.Phone.value)} {
        width: 180px;
    }
`;

export const BlockSetUpAsideWrapper = styled.div`
    padding: ${getSpacingToken('50')}px ${DEFAULT_SPACING}px;
    width: 100%;
`;

export const BlockSetUpVectorCell = styled(MatrixCellWrapperElement)<{
    isWarningCell?: boolean;
}>`
    border-bottom: ${getGreyBorderStyle};
    border-right: ${getGreyBorderStyle};
    ${({ isWarningCell, theme }) =>
        isWarningCell && `background: ${alpha(getToken('paletteSemanticOrange100')({ theme }), 0.5)};`}
`;

export const BlockSetupMatrixVectorCellWrapper = styled.div`
    padding: ${DEFAULT_SPACING}px;
    width: 100%;
`;

export const HeaderCellElement = styled(TimeUnitMatrixCell)`
    border-right: ${getGreyBorderStyle};
    justify-content: center;
`;
export const GuestsHeaderCellElement = styled(MatrixHeaderCellElement)`
    border-right: ${getGreyBorderStyle};
    align-items: center;
`;

export const InputWrapper = styled.div`
    padding: 0px ${DEFAULT_SPACING}px;
    width: 100%;
`;

export const BlockSetUpAsideTotalWrapper = styled.div`
    padding: ${getSpacingToken('50')}px ${DEFAULT_SPACING}px;
    width: 100%;
    text-align: right;
`;

export const BlockSetupMatrixVectorTotalCell = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    padding-left: ${DEFAULT_SPACING}px;
    padding-right: ${DEFAULT_SPACING}px;
`;

export const BlockSetUpAsideWrapperTotalRow = styled(BlockSetUpAsideWrapperRow)`
    height: ${TOTAL_CELL_HEIGHT}px;
`;

export const BlockSetUpVectorTotalCell = styled(BlockSetUpVectorCell)`
    height: ${TOTAL_CELL_HEIGHT}px;
`;

export const WarningBareIconButton = styled(BareIconButton)`
    color: ${getToken('textAlertWarning')};
`;
